// extracted by mini-css-extract-plugin
export default {"cookies":"CookieConsent_cookies__tYAG5","cookies__message":"CookieConsent_cookies__message__BuUF6"};